/**
 * Route metadata drives access, and the same declaration drives the sidebar. Renders 403 rather
 * than redirecting: a redirect to sign-in makes the user think their session died.
 */

import { Outlet, useMatches } from 'react-router';

import { can, selectUser } from '@pos/shared';

import { useAppSelector } from '@/app/hooks';
import { ForbiddenPage } from '@/pages/errors/ForbiddenPage';

export type RouteHandle = {
  permission?: string | readonly string[];
  title?: string;
};

export function PermissionRoute() {
  const user = useAppSelector(selectUser);
  const matches = useMatches();

  // Every matched route's requirement applies, so a permission on a parent cannot be escaped by
  // a child that forgets to repeat it.
  const required = matches.flatMap((match) => {
    const handle = match.handle as RouteHandle | undefined;
    if (handle?.permission === undefined) return [];
    return typeof handle.permission === 'string' ? [handle.permission] : [...handle.permission];
  });

  if (required.length > 0 && !can(user, ...required)) return <ForbiddenPage required={required} />;

  return <Outlet />;
}
